function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.33366 12.3333H10.667C10.8438 12.3333 11.0134 12.4036 11.1384 12.5286C11.2634 12.6536 11.3337 12.8232 11.3337 13C11.3337 13.1768 11.2634 13.3464 11.1384 13.4714C11.0134 13.5964 10.8438 13.6666 10.667 13.6666H1.33366C1.15685 13.6666 0.987279 13.5964 0.862254 13.4714C0.73723 13.3464 0.666992 13.1768 0.666992 13C0.666992 12.8232 0.73723 12.6536 0.862254 12.5286C0.987279 12.4036 1.15685 12.3333 1.33366 12.3333ZM0.666992 8.99998L7.33366 2.33331L9.33366 4.33331L2.66699 11H0.666992V8.99998ZM8.00033 1.66665L9.33366 0.333313L11.3337 2.33331L9.99966 3.66731L8.00033 1.66665Z",
  fill: "#1394DF"
});

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.d9633c75.svg";
export { ForwardRef as ReactComponent };